import { Body1, makeStyles, tokens } from '@fluentui/react-components';

import { useTypingRevealText } from '@shared/hooks';

const DEFAULT_PROGRESS_MESSAGE = 'Preparing your question...';

const useStyles = makeStyles({
  shimmer: {
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    overflowWrap: 'anywhere',
    // A soft highlight sweeps across the text itself - the "thinking" cue, in place of a spinner.
    backgroundImage: `linear-gradient(110deg, ${tokens.colorNeutralForeground4} 30%, ${tokens.colorNeutralForeground1} 50%, ${tokens.colorNeutralForeground4} 70%)`,
    backgroundSize: '220% 100%',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    color: 'transparent',
    animationName: {
      from: { backgroundPositionX: '220%' },
      to: { backgroundPositionX: '0%' },
    },
    animationDuration: '2.2s',
    animationTimingFunction: 'linear',
    animationIterationCount: 'infinite',
    '@media screen and (prefers-reduced-motion: reduce)': {
      animationName: 'none',
      backgroundImage: 'none',
      color: tokens.colorNeutralForeground2,
    },
  },
});

type TProps = {
  progressMessage?: string | null;
};

const AiAssistantProgressMessage = ({ progressMessage }: TProps) => {
  const message = progressMessage?.trim() || DEFAULT_PROGRESS_MESSAGE;
  const { text, isAnimating } = useTypingRevealText(message);

  const classes = useStyles();

  return (
    <Body1 className={classes.shimmer} title={message} aria-live={isAnimating ? 'off' : 'polite'}>
      {text || ' '}
    </Body1>
  );
};

export default AiAssistantProgressMessage;
